import React, { useState } from "react";
import "./SearchBar.css";
import { InputGroup, Form } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";

function SearchBar({ searchTerm, setSearchTerm }) {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const handleSearchChange = (event) => {
    const newSearchTerm = event.target.value;
    setSearchTerm(newSearchTerm);
  };

  return (
    <InputGroup
      className={`search-bar ${isFocused ? "search-bar-focused" : ""}`}
    >
      <InputGroup.Text>
        <FaSearch />
      </InputGroup.Text>
      <Form.Control
        value={searchTerm}
        placeholder="Search..."
        onChange={handleSearchChange}
        aria-label="Search"
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
    </InputGroup>
  );
}

export default SearchBar;
